<template>
    <div class="form-position login-form-wrap">
        <form @submit.prevent="login">
            <div>
                <div class="input-grid">
                    <label for="email">SalesTrekker E-Mail:</label>
                    <input type="email" id="email" required v-model="credentials.email"
                           placeholder="example@e-mail.com">
                </div>
                <div class="input-grid">
                    <label for="password">SalesTrekker Password:</label>
                    <input type="password" id="password" required minlength="6" v-model="credentials.password"
                           placeholder="******">
                </div>
            </div>
            <div class="relative-div">
                <button class="btn" :disabled="loginDisabled">Sign in</button>
                <preloader v-if="preloader"></preloader>
            </div>
            <div>
                <p><a href="https://salestrekker.com" target="_blank">Get 30-day free trial of SalesTrekker</a></p>
            </div>
        </form>
        <login-modal v-if="loginModal" @close="loginModal = false"></login-modal>
    </div>
</template>

<script>
    import LoginModal from './LoginModal';
    import Preloader from './Preloader';
    import AuthService from '../services/AuthService';

    export default {
        components: {
            'login-modal': LoginModal,
            preloader: Preloader
        },
        beforeCreate () {
            if (!AuthService.expirationCheck()) {
                this.$router.push('/email');
            }
        },
        data () {
            return {
                loginDisabled: false,
                credentials: {
                    email: '',
                    password: ''
                },
                loginModal: false,
                preloader: false
            };
        },
        methods: {
            async login () {
                this.loginDisabled = true;
                this.preloader = true;
                try {
                    const response = await AuthService.login(this.credentials);
                    AuthService.saveToken(response.data.authToken);
                    this.preloader = false;
                    this.$router.push('/email');
                } catch (e) {
                    this.loginModal = true;
                    this.preloader = false;
                    this.loginDisabled = false;
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/Login.vue